import { kebabCase } from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Card, CardBody, CardHeader, Row, ButtonGroup } from 'reactstrap';
import Icon from './icon';
const ListPanel = _ref => {
  let _ref$actionButton = _ref.actionButton,
    actionButton = _ref$actionButton === void 0 ? null : _ref$actionButton,
    _ref$favoriteButton = _ref.favoriteButton,
    favoriteButton = _ref$favoriteButton === void 0 ? null : _ref$favoriteButton,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children,
    _ref$controlInfo = _ref.controlInfo,
    controlInfo = _ref$controlInfo === void 0 ? null : _ref$controlInfo,
    _ref$onAdd = _ref.onAdd,
    onAdd = _ref$onAdd === void 0 ? null : _ref$onAdd,
    _ref$showNew = _ref.showNew,
    showNew = _ref$showNew === void 0 ? false : _ref$showNew,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$titleAfter = _ref.titleAfter,
    titleAfter = _ref$titleAfter === void 0 ? null : _ref$titleAfter,
    _ref$titleSub = _ref.titleSub,
    titleSub = _ref$titleSub === void 0 ? null : _ref$titleSub;
  const header = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
    className: "t-list-panel-header"
  }, /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, /*#__PURE__*/React.createElement("h3", {
    className: "t-main-title t-lp-title-".concat(kebabCase(title))
  }, title, titleAfter ? /*#__PURE__*/React.createElement("span", {
    className: "d-inline-flex align-items-center t-lp-title-after",
    style: {
      fontSize: '0.85em'
    }
  }, "\xA0", titleAfter) : null), titleSub ? /*#__PURE__*/React.createElement("div", {
    className: "small text-muted t-lp-subtitle"
  }, titleSub) : null), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement("div", {
    className: "float-md-right"
  }, /*#__PURE__*/React.createElement(ButtonGroup, null, controlInfo, favoriteButton, actionButton, showNew ? /*#__PURE__*/React.createElement(Button, {
    className: "t-button-new",
    id: "t-button-new",
    "data-testid": "t-button-new",
    size: "sm",
    onClick: onAdd
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "plus"
  }), " New") : undefined)))));
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, header), /*#__PURE__*/React.createElement(CardBody, null, children));
};
ListPanel.propTypes = {
  actionButton: PropTypes.element,
  favoriteButton: PropTypes.element,
  children: PropTypes.node,
  controlInfo: PropTypes.node,
  onAdd: PropTypes.func,
  showNew: PropTypes.bool,
  title: PropTypes.string,
  titleAfter: PropTypes.node,
  titleSub: PropTypes.node
};
export default ListPanel;